import { useTranslation } from 'react-i18next';
import type { PermissionCatalogueItem } from './api';
import {
  PERMISSION_GROUP_LABEL_KEYS,
  PERMISSION_GROUP_ORDER,
  PERMISSION_LABEL_KEYS,
} from './labels';
import styles from './Organization.module.css';

/**
 * YETKI SECICI — hem yetki duzenleyicide hem hesap acma formunda kullanilir.
 *
 * KATALOG SUNUCUDAN GELIR ve yalniz VERILEBILIR kodlari icerir. Yonetici
 * yetkileri (manageMembers, managePermissions, editOrganization, viewAuditLog)
 * sunucuda `is_org_grantable=false`; listeye HIC girmezler ve burada elle
 * eklenmemelidirler — yonetici zaten ORTUK olarak tam yetkilidir, ona ayrica
 * yetki yazmak "verilmis ama hicbir sey degistirmeyen" yalanci bir kayit
 * birakir (sunucu da ADMIN_HAS_IMPLICIT_PERMISSIONS ile reddeder).
 */

export type PermissionPickerProps = {
  catalogue: readonly PermissionCatalogueItem[];
  selected: readonly string[];
  onToggle: (code: string) => void;
  disabled?: boolean;
};

/** Katalogu gruplara ayirir; bilinen gruplar once, kalanlar geldigi sirada. */
const groupCatalogue = (
  catalogue: readonly PermissionCatalogueItem[],
): Array<{ group: string; items: PermissionCatalogueItem[] }> => {
  const buckets = new Map<string, PermissionCatalogueItem[]>();
  for (const item of catalogue) {
    const bucket = buckets.get(item.group);
    if (bucket) bucket.push(item);
    else buckets.set(item.group, [item]);
  }
  const ordered: Array<{ group: string; items: PermissionCatalogueItem[] }> = [];
  for (const group of PERMISSION_GROUP_ORDER) {
    const items = buckets.get(group);
    if (items) {
      ordered.push({ group, items });
      buckets.delete(group);
    }
  }
  for (const [group, items] of buckets) ordered.push({ group, items });
  return ordered;
};

export function PermissionPicker({
  catalogue,
  selected,
  onToggle,
  disabled = false,
}: PermissionPickerProps) {
  const { t } = useTranslation();

  return (
    <>
      {groupCatalogue(catalogue).map(({ group, items }) => {
        const groupKey = PERMISSION_GROUP_LABEL_KEYS[group];
        return (
          <div key={group} className={styles.permissionGroup}>
            {/* Grup adi bilinmiyorsa HAM KOD basilir: yeni bir sunucu grubu bu
                bolumu sessizce yok etmemeli. */}
            <p className={styles.groupTitle}>{groupKey === undefined ? group : t(groupKey)}</p>
            {items.map((item) => {
              const labelKey = PERMISSION_LABEL_KEYS[item.code];
              const label =
                item.descriptionTr || (labelKey === undefined ? item.code : t(labelKey));
              return (
                <label key={item.code} className={styles.permissionRow}>
                  <input
                    type="checkbox"
                    checked={selected.includes(item.code)}
                    disabled={disabled}
                    onChange={() => {
                      onToggle(item.code);
                    }}
                  />
                  <span className={styles.permissionText}>
                    <span>{label}</span>
                    <span className={styles.permissionCode}>{item.code}</span>
                  </span>
                </label>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
